// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spiely-options {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
  }


  .spiely-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 800px;
    margin: 0 auto;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 20px;
    background-color: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
  }
  
  .form-group-spiely {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    gap: 30px
  }

  .form-group-spiely-url {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    gap: 50px
  }

  .form-group-spiely-url label {
    font-weight: bold;
    text-align: left;
    white-space: nowrap;
    flex: 0 0 100px;
  }


  .form-group-sender-header {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    gap: 20px
  }

  .form-group-sender-header label {
    text-align: left;
  }

  .form-group-sender-header .domain-header-wrap {
    width: 50%;
  }
  
  .form-group-spiely label {
    width: 150px;
    font-weight: bold;
    text-align: left;
    white-space: nowrap;

  }

  .form-group-spiely-radio {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
  }

  .form-group-spiely-radio label {
    text-align: left;
    white-space: nowrap;
    width: 120px;
    font-weight: bold;
  }
  
  input[type="text"],
  input[type="url"],
  select {
    width: 100%;
    padding: 10px;
    border: 1px solid #d1d1d1;
    border-radius: 4px;
  }
  
  .radio-group {
    display: flex;
    gap: 20px;
  }
  
  .radio-group label {
    display: flex;
    gap: 5px;
  }

  .header-msg-type {
    display: flex
;
    justify-content: space-between;
    margin-right: 5px;
  }
  
  .info-text {
    font-size: 12px;
    color: #666;
    margin-top: 5px;
  }
  
  .form-actions {
    display: flex;
    justify-content: center;
    gap: 10px;
  }
  
  .btn-save {
    color: #fff;
    background-color: #44a67e;
    border: 1px solid #44a67e !important;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .btn-reset {
    background-color: #fb3d4e;
    color: #fff;
    border: 1px solid #fb3d4e;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
  }

  .shortUrlResponse {
    background-color: #28a745;
    color: #fff;
    border-radius: 5px;
  }

  .shortUrlResponse p {
    color: #fff;
    margin-top: 10px;
    padding: 10px;
    text-align: left;
  }
  

  /* Table Styling */
  .spiely-template-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  }
  
  .spiely-template-table th,
  .spiely-template-table td {
    padding: 12px 15px;
    border: 1px solid #ddd;
    font-size: 14px;
  }
  
  .spiely-template-table th {
    background-color: #f4f4f4;
    color: #373435;
    font-weight: 600;
    text-transform: uppercase;
    text-align: left;
  }
  
  .spiely-template-table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .spiely-template-table tbody tr:hover {
    background-color:  rgba(255, 204, 41, 0.2);
  }
  
  .spiely-template-table td {
    color: #373435;
  }
  
  .spiely-template-table tbody tr:last-child td {
    border-bottom: 2px solid #ffcc29;
  }

  /* Expand Button */
  .spiely-expand-btn {
    background: #373435;
    color: #ffcc29;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 16px;
  }
  
  .spiely-expand-btn:hover {
    background: #ffcc29;
    color: #373435;
  }
  
  /* Expanded Row */
  .spiely-expanded-row {
    background-color: #eef7ff;
  }
  
  .spiely-expanded-content {
    padding: 10px;
  }

  /* =========================================================== */

   .delete-short-url {
    background-color: #fb3d4e;
    color: #fff;
    border: 1px solid #fb3d4e;
    padding: 8px 10px;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 5px;
  }

  .btn-edit-callback {
    color: #fff;
    background-color: #44a67e;
    border: 1px solid #44a67e;
    padding: 8px 10px;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .delete-short-url:hover {
    background-color: #c82333;
  }
  
  .btn-edit-callback:hover {
    background-color: #3A7D44;
  }

  .short-url-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
    color: #373435;
  }

.wrap-add-spiely-link {
  margin: 0 40px;
}  

/* Filter Style */
.filter-short-url {
  display: flex;
  justify-content: end;
  align-items: center;
  margin-bottom: 15px;
  gap: 10px;
}

.filter-short-url label {
  font-size: 14px;
  font-weight: bold;
}

.filter-short-url input {
  width: 300px;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

/* ==========Message Note Style========= */
.spiely-modal-content-campaign .input-alert-combine {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.spiely-modal-content-campaign small {
  color: #373435;
  font-size: 12px;
  text-align: start;
}


/* Modal Style */
.spliely-modal-campaign {
  position: fixed;
  top: 50px;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.spiely-modal-content-campaign {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 50%;
  max-width: 90%; /* Makes it responsive */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transform: translateY(-50px);
  transition: transform 0.3s ease;
  word-wrap: break-word; /* Ensures words break and wrap */
  overflow-wrap: break-word; /* Additional support for text wrapping */
}

.spiely-modal-campaign.open .spiely-modal-content-campaign {
  transform: translateY(0);
}

.spiely-modal-content-campaign select {
  width: 30%;
  margin-bottom: 8px;
}

.spiely-modal-content-campaign h2 {
  margin-bottom: 20px;
  font-size: 22px;
  text-align: left;
}

.spiely-modal-content-campaign p {
  font-size: 16px;
  margin: 10px 0;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f9f9f9;
  word-wrap: break-word; 
  overflow-wrap: break-word; 
  max-width: 100%; 
  white-space: pre-wrap; 
  text-align: left;
}

.modal-buttons-spiely {
  display: flex;
  justify-content: end;
  margin-top: 20px;
  gap: 10px;
}

.modal-buttons-spiely button {
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
  background-color: #4caf50;
  color: white;
  transition: background-color 0.3s ease;
}

.modal-buttons-spiely .send-btn {
  color: #fff;
  background-color: #44a67e;
  border: 1px solid #44a67e;
}

.modal-buttons-spiely .close-btn {
  background-color: #f44336;
  color: #fff;
  border: 1px solid #f44336;
}`, "",{"version":3,"sources":["webpack://./src/components/SpielyManagement/SpielyManagement.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;;EAGA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;IAC1C,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB;EACF;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB;EACF;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;;EAGA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;;EAErB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;;IAGE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE;AACJ;IACI,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;;EAGA,kBAAkB;EAClB;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;;EAEA,kBAAkB;EAClB;IACE,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA,gEAAgE;;GAE/D;IACC,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;EAChB;;AAEF;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;;AAGA,gBAAgB;AAChB;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,cAAc,EAAE,wBAAwB;EACxC,yCAAyC;EACzC,4BAA4B;EAC5B,+BAA+B;EAC/B,qBAAqB,EAAE,iCAAiC;EACxD,yBAAyB,EAAE,yCAAyC;AACtE;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B","sourcesContent":[".spiely-options {\r\n    display: flex;\r\n    gap: 15px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n\r\n  .spiely-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    border: 1px solid #ddd;\r\n    border-radius: 5px;\r\n    padding: 20px;\r\n    background-color: #fff;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n    margin-bottom: 30px;\r\n  }\r\n  \r\n  .form-group-spiely {\r\n    margin-bottom: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 30px\r\n  }\r\n\r\n  .form-group-spiely-url {\r\n    margin-bottom: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 50px\r\n  }\r\n\r\n  .form-group-spiely-url label {\r\n    font-weight: bold;\r\n    text-align: left;\r\n    white-space: nowrap;\r\n    flex: 0 0 100px;\r\n  }\r\n\r\n\r\n  .form-group-sender-header {\r\n    margin-bottom: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px\r\n  }\r\n\r\n  .form-group-sender-header label {\r\n    text-align: left;\r\n  }\r\n\r\n  .form-group-sender-header .domain-header-wrap {\r\n    width: 50%;\r\n  }\r\n  \r\n  .form-group-spiely label {\r\n    width: 150px;\r\n    font-weight: bold;\r\n    text-align: left;\r\n    white-space: nowrap;\r\n\r\n  }\r\n\r\n  .form-group-spiely-radio {\r\n    margin-bottom: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n  .form-group-spiely-radio label {\r\n    text-align: left;\r\n    white-space: nowrap;\r\n    width: 120px;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  input[type=\"text\"],\r\n  input[type=\"url\"],\r\n  select {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: 1px solid #d1d1d1;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .radio-group {\r\n    display: flex;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .radio-group label {\r\n    display: flex;\r\n    gap: 5px;\r\n  }\r\n\r\n  .header-msg-type {\r\n    display: flex\r\n;\r\n    justify-content: space-between;\r\n    margin-right: 5px;\r\n  }\r\n  \r\n  .info-text {\r\n    font-size: 12px;\r\n    color: #666;\r\n    margin-top: 5px;\r\n  }\r\n  \r\n  .form-actions {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .btn-save {\r\n    color: #fff;\r\n    background-color: #44a67e;\r\n    border: 1px solid #44a67e !important;\r\n    padding: 10px 20px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .btn-reset {\r\n    background-color: #fb3d4e;\r\n    color: #fff;\r\n    border: 1px solid #fb3d4e;\r\n    padding: 10px 20px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .shortUrlResponse {\r\n    background-color: #28a745;\r\n    color: #fff;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  .shortUrlResponse p {\r\n    color: #fff;\r\n    margin-top: 10px;\r\n    padding: 10px;\r\n    text-align: left;\r\n  }\r\n  \r\n\r\n  /* Table Styling */\r\n  .spiely-template-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    text-align: left;\r\n  }\r\n  \r\n  .spiely-template-table th,\r\n  .spiely-template-table td {\r\n    padding: 12px 15px;\r\n    border: 1px solid #ddd;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .spiely-template-table th {\r\n    background-color: #f4f4f4;\r\n    color: #373435;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n    text-align: left;\r\n  }\r\n  \r\n  .spiely-template-table tbody tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .spiely-template-table tbody tr:hover {\r\n    background-color:  rgba(255, 204, 41, 0.2);\r\n  }\r\n  \r\n  .spiely-template-table td {\r\n    color: #373435;\r\n  }\r\n  \r\n  .spiely-template-table tbody tr:last-child td {\r\n    border-bottom: 2px solid #ffcc29;\r\n  }\r\n\r\n  /* Expand Button */\r\n  .spiely-expand-btn {\r\n    background: #373435;\r\n    color: #ffcc29;\r\n    border: none;\r\n    padding: 5px 10px;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .spiely-expand-btn:hover {\r\n    background: #ffcc29;\r\n    color: #373435;\r\n  }\r\n  \r\n  /* Expanded Row */\r\n  .spiely-expanded-row {\r\n    background-color: #eef7ff;\r\n  }\r\n  \r\n  .spiely-expanded-content {\r\n    padding: 10px;\r\n  }\r\n\r\n  /* =========================================================== */\r\n\r\n   .delete-short-url {\r\n    background-color: #fb3d4e;\r\n    color: #fff;\r\n    border: 1px solid #fb3d4e;\r\n    padding: 8px 10px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-left: 5px;\r\n  }\r\n\r\n  .btn-edit-callback {\r\n    color: #fff;\r\n    background-color: #44a67e;\r\n    border: 1px solid #44a67e;\r\n    padding: 8px 10px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .delete-short-url:hover {\r\n    background-color: #c82333;\r\n  }\r\n  \r\n  .btn-edit-callback:hover {\r\n    background-color: #3A7D44;\r\n  }\r\n\r\n  .short-url-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-top: 20px;\r\n    color: #373435;\r\n  }\r\n\r\n.wrap-add-spiely-link {\r\n  margin: 0 40px;\r\n}  \r\n\r\n/* Filter Style */\r\n.filter-short-url {\r\n  display: flex;\r\n  justify-content: end;\r\n  align-items: center;\r\n  margin-bottom: 15px;\r\n  gap: 10px;\r\n}\r\n\r\n.filter-short-url label {\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n}\r\n\r\n.filter-short-url input {\r\n  width: 300px;\r\n  padding: 12px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n}\r\n\r\n/* ==========Message Note Style========= */\r\n.spiely-modal-content-campaign .input-alert-combine {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n}\r\n\r\n.spiely-modal-content-campaign small {\r\n  color: #373435;\r\n  font-size: 12px;\r\n  text-align: start;\r\n}\r\n\r\n\r\n/* Modal Style */\r\n.spliely-modal-campaign {\r\n  position: fixed;\r\n  top: 50px;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.spiely-modal-content-campaign {\r\n  background: white;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  width: 50%;\r\n  max-width: 90%; /* Makes it responsive */\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\r\n  transform: translateY(-50px);\r\n  transition: transform 0.3s ease;\r\n  word-wrap: break-word; /* Ensures words break and wrap */\r\n  overflow-wrap: break-word; /* Additional support for text wrapping */\r\n}\r\n\r\n.spiely-modal-campaign.open .spiely-modal-content-campaign {\r\n  transform: translateY(0);\r\n}\r\n\r\n.spiely-modal-content-campaign select {\r\n  width: 30%;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.spiely-modal-content-campaign h2 {\r\n  margin-bottom: 20px;\r\n  font-size: 22px;\r\n  text-align: left;\r\n}\r\n\r\n.spiely-modal-content-campaign p {\r\n  font-size: 16px;\r\n  margin: 10px 0;\r\n  padding: 10px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  background-color: #f9f9f9;\r\n  word-wrap: break-word; \r\n  overflow-wrap: break-word; \r\n  max-width: 100%; \r\n  white-space: pre-wrap; \r\n  text-align: left;\r\n}\r\n\r\n.modal-buttons-spiely {\r\n  display: flex;\r\n  justify-content: end;\r\n  margin-top: 20px;\r\n  gap: 10px;\r\n}\r\n\r\n.modal-buttons-spiely button {\r\n  padding: 10px 20px;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  border: none;\r\n  border-radius: 4px;\r\n  background-color: #4caf50;\r\n  color: white;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.modal-buttons-spiely .send-btn {\r\n  color: #fff;\r\n  background-color: #44a67e;\r\n  border: 1px solid #44a67e;\r\n}\r\n\r\n.modal-buttons-spiely .close-btn {\r\n  background-color: #f44336;\r\n  color: #fff;\r\n  border: 1px solid #f44336;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
